module.exports = __webpack_public_path__ + "img/linkedin-white.942e4daa.svg";